var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 25,
    viewBox: "0 0 37 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6328 4.25335C35.4291 3.5264 35.0321 2.86825 34.4842 2.34887C33.9207 1.81352 33.2302 1.43057 32.4777 1.23617C29.6615 0.493871 18.3785 0.493871 18.3785 0.493871C13.6748 0.440355 8.97222 0.675734 4.29735 1.19868C3.54484 1.40744 2.85558 1.79895 2.29089 2.33837C1.73604 2.87223 1.33415 3.53055 1.12421 4.25185C0.619883 6.96873 0.374848 9.72738 0.392405 12.4906C0.37441 15.2514 0.618844 18.0091 1.12421 20.7294C1.32965 21.4477 1.73004 22.103 2.28639 22.6324C2.84274 23.1617 3.53555 23.5441 4.29735 23.7466C7.15107 24.4874 18.3785 24.4874 18.3785 24.4874C23.0882 24.541 27.7968 24.3056 32.4777 23.7826C33.2302 23.5882 33.9207 23.2052 34.4842 22.6699C35.0319 22.1506 35.4284 21.4923 35.6313 20.7654C36.1488 18.0495 36.4005 15.2897 36.3826 12.5251C36.4216 9.74877 36.1703 6.97596 35.6328 4.25185V4.25335ZM14.7915 17.6252V7.35751L24.179 12.4921L14.7915 17.6252Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube_logo.b7347feb07a8f158c2d0eb07292967f3.svg";
export { ForwardRef as ReactComponent };